import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
// Replace with your actual Firebase config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyB8Ap9F6IPV79U6sT6HzJ_4tkuTmA55gJc",
  authDomain: "cadirect-fea91.firebaseapp.com",
  databaseURL: "https://cadirect-fea91-default-rtdb.firebaseio.com",
  projectId: "cadirect-fea91",
  storageBucket: "cadirect-fea91.firebasestorage.app",
  messagingSenderId: "928235816313",
  appId: "1:928235816313:web:3d9a4ef987250b42ad5ba8",
  measurementId: "G-YZNVXJWXEC",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Create a separate Firebase app instance for client user creation
// This prevents interference with the main admin authentication session
const clientAppConfig = {
  ...firebaseConfig,
  // Use the same config but create a separate app instance
};
const clientApp = initializeApp(clientAppConfig, 'clientApp');
export const clientAuth = getAuth(clientApp);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
